import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { microAppPathsArraySelector, useAppStore, useMicroAppStore } from "../../store";
import { getGlobalShareConfigValueByKey } from "../../utils/globalShareConfig";
import { useMemoizedFn } from "ahooks";
import { useRef } from "react";
import { generatePath, matchRoutes, useLocation, useNavigate } from "react-router-dom";
export var useLayoutNavigate = function useLayoutNavigate() {
  var isTabsMode = getGlobalShareConfigValueByKey("tabsMode");
  var prevSign = useRef("");
  var panes = useAppStore(function (s) {
    return s.panes;
  });
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname,
    search = _useLocation.search;
  var setPanes = useAppStore(function (s) {
    return s.setPanes;
  });
  var microApps = useMicroAppStore(function (s) {
    return s.microApps;
  });
  var microAppPaths = useAppStore(microAppPathsArraySelector);
  var navigate = useNavigate();
  var navigateByPath = useMemoizedFn(function (prevPath, options) {
    var path = prevPath;
    var repeatSign = "".concat(path).concat(JSON.stringify(options));
    if (repeatSign === prevSign.current) {
      return;
    }
    prevSign.current = repeatSign;
    setTimeout(function () {
      prevSign.current = "";
    }, 400);

    // 非tabs模式不做页签缓存，无需对比panes，这里全部置空
    var newPanes = isTabsMode ? _toConsumableArray(panes) : [];
    var newPane = newPanes.find(function (pane) {
      return pane.path === path;
    });
    var prevPane = newPanes.find(function (pane) {
      return pane.path === pathname;
    });
    var prevSearch = search;
    if (options !== null && options !== void 0 && options.ignoreSearch) {
      // 强制更新清空search缓存
      if (newPane) {
        newPane.search = "";
        setPanes(newPanes);
      }
    } else if (prevSearch && prevPane) {
      // 保留之前的search缓存
      prevPane.search = prevSearch;
      setPanes(newPanes);
    }
    var cacheSearch = newPane === null || newPane === void 0 ? void 0 : newPane.search;
    if (cacheSearch) {
      path = "".concat(path).concat(cacheSearch);
    }
    // 非tabs模式下，cache和search无所谓，主要要找到子应用传递上来的microAppPath地址映射
    var isMicroAppPath = microApps.some(function (app) {
      return path.startsWith(app.baseRoute);
    });
    if (isMicroAppPath) {
      var _ref = matchRoutes(microAppPaths, path || "") || [],
        _ref2 = _slicedToArray(_ref, 1),
        matchWitchMicroAppRoute = _ref2[0];

      // 找到真实的子应用路由解析规则
      if (matchWitchMicroAppRoute && matchWitchMicroAppRoute.route.path !== "*") {
        var realPath = generatePath(matchWitchMicroAppRoute.route.originPath || "", matchWitchMicroAppRoute.params);
        navigate(realPath + search, options === null || options === void 0 ? void 0 : options.navigateOptions);
        return;
      }
    }
    navigate(path, options === null || options === void 0 ? void 0 : options.navigateOptions);
  });
  var navigateWithoutCache = function navigateWithoutCache(path, options) {
    navigateByPath(path, _objectSpread(_objectSpread({}, options), {}, {
      ignoreSearch: true
    }));
  };
  return {
    navigateByPath: navigateByPath,
    navigateWithoutCache: navigateWithoutCache
  };
};